module.exports = __webpack_public_path__ + "img/kangaroo_pocket_height.70025b05.png";